import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";

const CustomerViewTable = ({ customer = {} }) => {
  const formatDate = (date) => {
    if (!date) return "--";
    const d = new Date(date);
    return d.toLocaleDateString("en-IN", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  const renderField = (label, value) => (
    <div className="col-lg-4 col-md-6 col-sm-12">
      <div className="p-3 bg-white rounded-4 shadow-sm h-100 border-0 position-relative overflow-hidden">
        <small className="text-secondary text-uppercase fw-semibold mb-1 d-block">
          {label}
        </small>
        <div className="fw-semibold text-dark fs-6">
          {value || <span className="text-muted">--</span>}
        </div>
      </div>
    </div>
  );

  const renderPhoto = (label, src) => {
    return (
      <div className="col-lg-3 col-md-4 col-sm-6">
        <div className="card border-0 shadow-sm rounded-4 overflow-hidden h-100">
          <div className="card-body text-center p-2">
            <small className="text-secondary fw-semibold d-block mb-2">
              {label}
            </small>
            <div className="overflow-hidden rounded-3">
              <img
                src={src ? src : ""}
                alt={label}
                className="img-fluid rounded-3 avatar xxl"
                onError={(e) => {
                  e.target.onerror = null;
                }}
              />
            </div>
          </div>
        </div>
      </div>
    );
  };


  const Section = ({ title, children }) => (
    <div className="mb-5">
      <h5 className="fw-bold text-dark mb-3 border-bottom pb-2 position-relative">
        <span className="pe-2">{title}</span>
      </h5>
      <div className="row g-3">{children}</div>
    </div>
  );

  return (

    <div className="rounded-4 p-4 shadow-sm bg-light bg-opacity-75">
      {/* === Photos === */}
      <Section title="Uploaded Photos">
        {renderPhoto(
          "Profile Image",
          customer.profile_image
        )}
        {renderPhoto(
          "Guest Photo",
          customer.img_guest
        )}
        {renderPhoto(
          "Photo Front",
          customer.img_front
        )}
        {renderPhoto(
          "Photo Back",
          customer.img_back
        )}        
      </Section>

      {/* === Personal Details === */}
      <Section title="Personal Details">
        {renderField("Customer Number", customer.customer_number)}
        {renderField("Username", customer.username)}
        {renderField("First Name", customer.first_name)}
        {renderField("Last Name", customer.last_name)}
        {renderField("Email", customer.email)}
        {renderField("Phone", customer.customer_phone)}
        {renderField("Gender", customer.gender)}
        {renderField("Date of Birth", formatDate(customer.dob))}
        {renderField("Anniversary", formatDate(customer.anniversary))}
        {renderField("Father Name", customer.father_name)}
        {renderField("Profession", customer.profession)}
        {renderField("Membership Type", customer.membership_type)}
        {renderField("Nationality", customer.nationality)}
        {renderField("Is Nationality", customer.is_nationality)}
      </Section>

      {/* === Contact & Address === */}
      <Section title="Contact & Address">
        {renderField("Address", customer.address)}
        {renderField("City", customer.city)}
        {renderField("Zip Code", customer.zip_code)}
        {renderField("Country", customer.country)}
        {renderField("Contact Type", customer.contact_type)}
        {renderField("Balance", customer.balance)}
      </Section>

      {/* === Identity Info === */}
      <Section title="Identity Details">
        {renderField("PID Type", customer.pid_type)}
        {renderField("PID Number", customer.pid)}
        {renderField("Passport", customer.passport)}
        {renderField("Visa No", customer.visa_no)}
        {renderField("Purpose", customer.purpose)}
        {renderField("Signup Date", formatDate(customer.signup_date))}
        {renderField(
          "Status",
          customer.status === "1" ? "Active" : "Inactive"
        )}
      </Section>
    </div>
  );
};

export default CustomerViewTable;
